(() => {
  const setup = (form) => {
    if (form.dataset.suggestionsReady === 'true') return;
    form.dataset.suggestionsReady = 'true';

    const input = form.querySelector('input[type="search"]');
    const panel = form.querySelector('.header-search-suggestions');
    const list = form.querySelector('.header-search-suggestions__list');
    const status = form.querySelector('.header-search-suggestions__status');
    const viewAll = form.querySelector('.header-search-suggestions__all');
    if (!input || !panel || !list || !status || !viewAll) return;

    let timer;
    let controller;
    let activeIndex = -1;

    const close = () => {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    };

    const open = () => {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const money = (value) => {
      const amount = Number(value);
      if (!Number.isFinite(amount) || amount === 0) return 'Price on request';
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(amount);
    };

    const render = (products, query) => {
      list.replaceChildren();
      status.textContent = products.length ? `${products.length} matching pieces` : `No pieces found for “${query}”`;
      viewAll.href = `/search?q=${encodeURIComponent(query)}&type=product`;

      products.forEach((product, index) => {
        const link = document.createElement('a');
        link.className = 'header-search-suggestions__item';
        link.href = product.url;
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        link.dataset.index = String(index);

        const image = document.createElement('img');
        image.className = 'header-search-suggestions__image';
        image.alt = '';
        image.loading = 'lazy';
        image.width = 128;
        image.height = 128;
        if (product.featured_image?.url) image.src = `${product.featured_image.url}&width=128`;

        const content = document.createElement('span');
        content.className = 'header-search-suggestions__content';
        const title = document.createElement('span');
        title.className = 'header-search-suggestions__title';
        title.textContent = product.title;
        const price = document.createElement('span');
        price.className = 'header-search-suggestions__price';
        price.textContent = money(product.price);
        content.append(title, price);
        link.append(image, content);
        list.append(link);
      });
      open();
    };

    const search = async () => {
      const query = input.value.trim();
      if (!query) return close();
      controller?.abort();
      controller = new AbortController();
      try {
        const url = new URL('/search/suggest.json', location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('resources[options][unavailable_products]', 'hide');
        const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`Search failed: ${response.status}`);
        const data = await response.json();
        render(data.resources?.results?.products || [], query);
      } catch (error) {
        if (error.name !== 'AbortError') close();
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(search, 140);
    });

    input.addEventListener('keydown', (event) => {
      const items = [...list.querySelectorAll('.header-search-suggestions__item')];
      if (event.key === 'Escape') return close();
      if (!items.length || !['ArrowDown', 'ArrowUp', 'Enter'].includes(event.key)) return;
      if (event.key === 'Enter' && activeIndex < 0) return;
      event.preventDefault();
      if (event.key === 'Enter') return items[activeIndex]?.click();
      activeIndex = event.key === 'ArrowDown' ? (activeIndex + 1) % items.length : (activeIndex - 1 + items.length) % items.length;
      items.forEach((item, index) => item.setAttribute('aria-selected', String(index === activeIndex)));
      items[activeIndex]?.scrollIntoView({ block: 'nearest' });
    });

    input.addEventListener('focus', () => {
      if (input.value.trim() && list.children.length) open();
    });
    document.addEventListener('pointerdown', (event) => {
      if (!form.contains(event.target)) close();
    });
  };

  const init = () => document.querySelectorAll('[data-precioux-search]').forEach(setup);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
